import { useEffect, useState } from "react";
import { Record, useRecordContext } from "react-admin";
import Field from "./Field";

export const getObjectValue = (record: Record, source: string, type = "text") => {
    const s = source.split(".");
    let v: any = record;
    let newIndex = s.shift();
    while (newIndex !== undefined && v !== undefined) {
        v = v && v[newIndex];
        if (v && v.constructor === Array && v.length > 0) {
            v = v[0];
        }
        newIndex = s.shift();
    }
    if (type.toLocaleLowerCase() === "date") {
        v = new Date(v).toLocaleDateString();
    }
    return v;
};

const ObjectField = ({ type = "text", ...props }) => {
    const record = useRecordContext();
    const [value, setValue] = useState(null);
    useEffect(() => {
        setValue(getObjectValue(record, props.source, type));
    }, [record, props.source, type]);
    return <Field {...props} value={value} />
};

ObjectField.defaultProps = {
    addLabel: true
};

export default ObjectField;